import { AppLink } from '@/shared/components/AppLink';
import emptyBrowsingHistoryImg from '@/shared/assets/images/empty-browsing-history.png';
import { PlpHeader } from '@/features/plp/presentation/components/PlpHeader';
import { RECENTLY_VIEWED_HEADER } from '../../infra/mappers/browsingHistory.mapper';

export function RecentlyViewedEmpty() {
  return (
    <>
      <PlpHeader title={RECENTLY_VIEWED_HEADER} showDesktopBanner={false} />
      <div className="mx-auto flex max-w-[1520px] flex-col items-center px-4 py-8 text-center">
        <div className="mb-6">
          <img
            src={emptyBrowsingHistoryImg}
            alt="Browsing History"
            className="mx-auto h-[134px] w-[138px] max-w-full"
            width={138}
            height={134}
          />
        </div>
        <p className="mb-6 max-w-md text-sm text-gray-700">
          Recently viewed designs will be available here for your convenience.
        </p>
        <AppLink
          to="/jewellery.html"
          className="inline-flex items-center justify-center rounded bg-[#2B5DA9] px-6 py-2.5 text-sm font-semibold uppercase tracking-wide text-white hover:bg-[#244a87]"
        >
          Start Browsing
        </AppLink>
      </div>
    </>
  );
}
